import React, { useState, useEffect } from 'react'

import PanalLoadingTemplate from '../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { Loader, Message, Panel, Placeholder, Row } from 'rsuite'
import AttachFilesDocWidget from '../attachfiles/AttachFilesDocWidget'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { getOldInfomaAttachments } from '../../redux/actions/attachments'
import LoaderProcessing from '../../components/loader/LoaderProcessing'

export default function InfomaFilesOldWidget({ projectId, ...props }) {
  const [schema, setSchema] = useState()
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const { Paragraph } = Placeholder

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getOldInfomaAttachments(proposalId)
      setSchema(_schema)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <Panel header="เอกสารจากระบบ Infoma">
        <Message showIcon type="error" description={DEFAULT_ERR_MSG} />
      </Panel>
    )
  }

  if (!schema || isLoading) {
    return (
      <Panel header="เอกสารจากระบบ Infoma">
        <LoaderProcessing />
      </Panel>
    )
  }

  return (
    <>
      {schema && (
        <>
          <AttachFilesDocWidget schema={schema} infoma={true} />

          <br />
        </>
      )}
    </>
  )
}
